import { render, staticRenderFns } from "./follow-record-base.vue?vue&type=template&id=f1942d44"
import script from "./follow-record-base.vue?vue&type=script&lang=ts"
export * from "./follow-record-base.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports